<template>
  <div class="category-item">
    <div class="item-row" :style="{ paddingRight: (category.level * 20) + 'px' }">
      <!-- آیکون باز/بسته شدن -->
      <span class="expand-icon" @click="toggle" v-if="hasChildren">
        {{ category.expanded ? '−' : '+' }}
      </span>
      <span class="expand-icon-placeholder" v-else></span>

      <!-- تصویر -->
      <div class="item-image">
        <img
            v-if="imageUrl && !imgFailed"
            :src="img_source(imageUrl)"
            @error="onImgError"
            class="thumbnail"
        />
        <div v-else class="thumbnail-placeholder">!</div>
      </div>

      <!-- نام (با هایلایت جستجو) -->
      <span class="item-name" v-html="highlightedName"></span>

      <!-- دکمه‌های عملیات -->
      <div class="item-actions">
        <button class="action-btn edit-btn" @click.stop="$emit('edit', category)" title="ویرایش">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
          </svg>
        </button>
        <button class="action-btn delete-btn" @click.stop="$emit('delete', category)" title="حذف">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- فرزندان (در صورت باز بودن) -->
    <div v-if="category.expanded && hasChildren" class="children">
      <tree-management-item
          v-for="child in category.children"
          :key="child.id"
          :category="child"
          :search-query="searchQuery"
          @toggle="$emit('toggle', $event)"
          @edit="$emit('edit', $event)"
          @delete="$emit('delete', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeManagementItem',
  props: {
    category: { type: Object, required: true },
    searchQuery: { type: String, default: '' }
  },
  data() {
    return {
      imgFailed: false
    };
  },
  computed: {
    hasChildren() {
      return this.category.children && this.category.children.length > 0;
    },
    imageUrl() {
      const img = this.category.image;
      const url = img && typeof img === 'object' ? img.url : img;
      return url || null;
    },
    highlightedName() {
      const name = String(this.category.name || '');
      const q = (this.searchQuery || '').trim();
      if (!q) return this.escapeHtml(name);
      const regex = new RegExp(this.escapeRegExp(q), 'gi');
      const escaped = this.escapeHtml(name);
      return escaped.replace(regex, (m) => `<mark class="search-highlight">${this.escapeHtml(m)}</mark>`);
    }
  },
  methods: {
    toggle() {
      if (this.hasChildren) this.$emit('toggle', this.category);
    },
    onImgError() {
      this.imgFailed = true;
    },
    escapeHtml(s) {
      return String(s)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
    },
    escapeRegExp(s) {
      return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
  },
  watch: {
    category: {
      handler() { this.imgFailed = false; },
      deep: true
    }
  }
};
</script>

<style scoped>
.category-item {
  font-size: 0.95rem;
  user-select: none;
}

.item-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 6px;
  transition: background 0.1s;
}
.item-row:hover {
  background: #3a3a3a;
}

.expand-icon {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #3a3a3a;
  color: #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
}
.expand-icon-placeholder {
  width: 20px;
  height: 20px;
  display: inline-block;
}

.item-image {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
  background: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #555;
}
.thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.thumbnail-placeholder {
  color: #888;
  font-size: 14px;
  font-weight: bold;
}

.item-name {
  flex: 1;
  color: #eaeaea;
  word-break: break-word;
}

.item-actions {
  display: flex;
  gap: 6px;
  opacity: 0.5;
  transition: opacity 0.2s;
}
.item-row:hover .item-actions {
  opacity: 1;
}

.action-btn {
  background: none;
  border: none;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  color: #ccc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.action-btn:hover {
  background: #4a5568;
}
.edit-btn:hover {
  color: #48bb78;
}
.delete-btn:hover {
  color: #f56565;
}

.children {
  margin-right: 20px;
}

.search-highlight {
  background: #2b6e4f;
  color: #fff;
  padding: 0 2px;
  border-radius: 4px;
}
</style>